var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPostComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.937,
    height: 21.94,
    viewBox: "0 0 21.937 21.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat_5_",
    "data-name": "chat (5)",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M4.156,18.05H6.35v1.813a2.613,2.613,0,0,0,1.255,2.328,1.939,1.939,0,0,0,.938.249,1.962,1.962,0,0,0,1.044-.311l6.48-4.079h2.714a3.66,3.66,0,0,0,3.656-3.656V4.156A3.66,3.66,0,0,0,18.781.5H4.156A3.66,3.66,0,0,0,.5,4.156V14.394A3.66,3.66,0,0,0,4.156,18.05ZM1.962,4.156A2.2,2.2,0,0,1,4.156,1.962H18.781a2.2,2.2,0,0,1,2.194,2.194V14.394a2.2,2.2,0,0,1-2.194,2.194H15.856a.737.737,0,0,0-.39.112L8.808,20.891a.453.453,0,0,1-.5.02,1.167,1.167,0,0,1-.5-1.047V17.319a.731.731,0,0,0-.731-.731H4.156a2.2,2.2,0,0,1-2.194-2.194Z",
    fill: "#40eefe"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostComment);
export default __webpack_public_path__ + "static/media/post-comment.2b74fee6cc0559d838809ee992d5c761.svg";
export { ForwardRef as ReactComponent };